module.exports = __webpack_public_path__ + "static/img/turntableText.e64912b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/turntableText.png
// module id = 7qKW
// module chunks = 1